import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { ExcelService } from '../../services/excel.service';
import { UnidadeProdutiva } from "../../entities/unidade-produtiva";

@Component({
  selector: 'app-modal-excel-bci',
  templateUrl: './modal-excel-bci.component.html',
  styleUrls: ['./modal-excel-bci.component.scss']
})
export class ModalExcelBciComponent implements OnInit {

  // @Input para receber o título do modal
  @Input() titulo: string = 'Detalhes';

  // @Input para receber os dados do item
  @Input() dados: any; // O objeto com os dados do item selecionado

  // @Output para notificar o componente pai quando o modal for fechado
  @Output() fechar = new EventEmitter<void>();

  constructor(
      private excelService: ExcelService
  ) { }

  ngOnInit(): void {
    console.log('Modal aberto com dados:', this.dados);
  }

  onFechar(): void {
    this.fechar.emit();
  }

formatNumberManual(value: number | string): string {
  if (value === null || value === undefined) {
    return '';
  }

  const num = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;

  if (isNaN(num)) {
    return String(value); // Retorna o valor original se não for um número válido
  }

  // Usar Intl.NumberFormat para formatação de milhar
  // 'pt-BR' especifica o locale para usar o padrão brasileiro (ponto como separador de milhar)
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(num);
}

private toNumber(value: number | string): number {
  if (value === null || value === undefined) {
    return 0;
  }

  const num = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;

  return isNaN(num) ? 0 : num;
}

getAreaConversao(item: UnidadeProdutiva): number {
  const areaConversao = this.toNumber(item && item.areaConversao);

  return areaConversao === 0
    ? this.toNumber(item && item.areaAlgodao)
    : areaConversao;
}

calcularProducaoPluma(item: UnidadeProdutiva): number {
  return this.getAreaConversao(item) * this.toNumber(item && item.produtividadePluma);
}

  exportarGridParaExcel(): void {

    console.log(this.dados);
    if (this.dados) {
 
    const lista = [this.dados];

    const dados = lista.map(item => ({
      "PU/LF Code CÓDIGO DA FAZENDA": item.numeroCertificadoBCI,
      "PU/LF Name NOME DA UNIDADE PRODUTIVA": item.nomeUnidadeProdutiva,
      "State Base": item.uf,
      "LF/PU State Nome associacao": item.nomeAssociacao,
      "Group Name Nome do Grupo (new - Due Diligence)": item.tipo ==='Grupo' ? item.produtorGrupo : "-",
      "LF/PU Owner PROPRIETÁRIO DA FAZENDA": item.tipo ==='Produtor' ? item.produtorGrupo : "-",
      "LF/PU Adress Endereço da Unidade Produtiva": item.endereco,
      "LF/PU City MUNICÍPIO": item.municipio,
      "LF/PU Geolocation (Latitude) (new - traceability)": item.latitude,
      "LF/PU Geolocation (Longitude) (new - traceability)": item.longitude,
      "Area under Cotton Production (ha) ÁREA PLANTADA (ha)": this.formatNumberManual(item.areaAlgodao),
      "Licensed Area (ha) AREA LICENCIADA (ha)": this.formatNumberManual(this.getAreaConversao(item)),
      "Lint yield per hectare (Kg /ha) PRODUTIVIDADE PLUMA (kg/ha)": this.formatNumberManual(item.produtividadePluma),
      "Lint Production (kg) PRODUÇÃO PLUMA (kg)": this.formatNumberManual(this.calcularProducaoPluma(item)) ,
    }));

      this.excelService.exportToExcel(dados, 'DadosDaGridCompleta');
    } else {
      console.warn('Nenhum dado na grid para exportar.');
      alert('Não há dados na grid para exportar!');
    }
  }

    // Método que "desformata" o valor digitado pelo usuário
  parseNumber(value: string): number | null {
    if (value === null || value === undefined || value.trim() === '') {
      return null;
    }

    // Remove os pontos de milhar e substitui a vírgula decimal por ponto (se houver)
    // Isso é crucial para que parseFloat entenda o número corretamente.
    const cleanedValue = value.replace(/\./g, '').replace(/,/g, '.');
    const parsed = parseFloat(cleanedValue);

    return isNaN(parsed) ? null : parsed;
  }

}
